import { Component,EventEmitter } from '@angular/core';

import {  BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { SharedConsts } from '../../constants';
import { SharedService } from '../../services/shared.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-brand-modal',
  standalone: false,
  templateUrl: './brand-modal.component.html',
  styleUrl: './brand-modal.component.scss'
})
export class BrandModalComponent {

  public event: EventEmitter<any> = new EventEmitter();
  brandsList:Array<any>=[];
  originalBrandListing:Array<any>=[];
  headerBrandsAlphabet:Array<any>=[];
  searchText:string='';
  searchInput = new Subject<string>();
  has_searched_text:boolean=false;
  selectedBrandId:number;
  isScreenProductCatalogue:boolean=false;
  categoryId:any;

  constructor(
    public bsModalRef: BsModalRef,
    private toastr:ToastrService,
    private route:ActivatedRoute,
    private statePersist:StatePersistService,
    private sharedService:SharedService
    ){}

  ngOnInit(){
    this.searchInput.pipe(
      debounceTime(1500),
      distinctUntilChanged())
      .subscribe((value:any) => {   
        this.onSearchedText(value);
    });
  }

  getKeyUpEnterValue(event:any): void {

  
    if (event.key === "Enter") {
      this.onSearchedText(event.target.value);
      this.has_searched_text = true;
      return
    }

    if(this.has_searched_text && event.target.value == ''){
     this.onSearchedText(event.target.value);
     this.searchInput.next('') 
    }

    if(event.target.value.length >= 3 && event.target.value){
      this.searchInput.next(event.target.value);
      this.has_searched_text = true;
    }else{
      this.searchInput.next('')
    }

  }

  onClearSearch():void{
      this.onSearchedText('');
      this.searchInput.next('');
      this.searchText = '';
  }


  onSearchedText(searchString:string):void{
    if(searchString){

      const lowerTerm = searchString.toLowerCase();
      const filtered = [];

      let currentGroup = null;
      let currentGroupHasMatch = false;

      for (const item of this.originalBrandListing) {
        if (!item.id) {
        // This is a heading (e.g., { id: '', label: 'A' })
        currentGroup = { ...item };
        currentGroupHasMatch = false;
          } else {
          // This is a brand
          if (item.label.toLowerCase().includes(lowerTerm)) {
          if (!currentGroupHasMatch && currentGroup) {
            filtered.push(currentGroup); // Add heading only if match is found under it
            currentGroupHasMatch = true;
          }
          filtered.push(item); // Add the matching brand
          }
        }
      }
      if(filtered.length){
        this.brandsList = [...filtered];
      }else{
        this.brandsList = [];
      }
    }else{
      this.brandsList = [...this.originalBrandListing];
    }

  }

  onBrandFilterApply():void{ 
    if(!this.selectedBrandId){
      this.toastr.error(SharedConsts['ERROR_BRAND_NOT_SELECTED']);
      return
    };
    let productData = JSON.parse(JSON.stringify(this.statePersist.getLocalStorage('product_data')));
    productData = {...productData,brand_filter:this.selectedBrandId.toString()};

    this.statePersist.setLocalStorage('product_data', productData); 
    this.sharedService.redirectAsBrandSelected(this.selectedBrandId,this.isScreenProductCatalogue,this.route,this.categoryId ? this.categoryId : '');
    this.bsModalRef?.hide()
  }

}
